<template>
  <!-- <NuxtPage :key="$route.fullPath" /> -->
  <NuxtPage />
</template>

<script setup>
import { ID_INJECTION_KEY } from "element-plus";
provide(ID_INJECTION_KEY, {
  prefix: 100,
  current: 0,
});
</script>
